<template>
  <div>
    <section class="dialogsBox" v-show="!rejectIsShow && auditIsShow">
      <div>
        <h3>财务审核</h3>
        <a @click="rejectCancel" class="close">
          <a-icon type="close-circle" style="font-size: 30px; color: #333" />
        </a>
        <ul v-if="details != ''">
          <li>
            <label>费用名称：</label>
            <p>{{ details.name }}</p>
          </li>
          <li>
            <label>费用金额：</label>
            <p>{{ Number(details.amount) + "元" }}</p>
          </li>
          <li>
            <label>提交人：</label>
            <p>{{ details.create_user_name }}</p>
          </li>
          <li class="labelHeight" v-if="details.type == 1">
            <label> <i>*</i>开票日期： </label>
            <a-date-picker v-model="invoice_date" />
          </li>
          <li class="labelHeight" v-if="details.type == 1">
            <label> <i>*</i>开票金额： </label>
            <a-input-number v-model="invoice_amount" />
            <span style="line-height: 32px">&nbsp;元</span>
          </li>
          <li>
            <label> <i>*</i>票据： </label>
            <a-radio-group v-model="is_ticket">
              <a-radio :value="2">票据齐全</a-radio>
              <a-radio :value="1">票据不全</a-radio>
            </a-radio-group>
          </li>
        </ul>
        <div>
          <a-button type="danger" @click="auditReject">驳回</a-button>
          <a-button type="primary" @click="auditPass">同意</a-button>
        </div>
      </div>
    </section>
    <!-- 驳回 -->
    <section class="dialogsBox" v-show="rejectIsShow">
      <div>
        <h3>驳回</h3>
        <ul>
          <li>
            <a-textarea
              v-model="reason"
              placeholder="请输入驳回原因"
              style="width: 300px"
            />
          </li>
        </ul>
        <div>
          <a-button @click="rejectCancel">取消</a-button>
          <a-button type="primary" @click="rejectSure">确认</a-button>
        </div>
      </div>
    </section>
    <!-- 驳回 end -->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      auditIsShow: true,
      reason: "",
      rejectIsShow: false,
      details: {},
      invoice_date: "",
      invoice_amount: null,
      is_ticket: ""
    };
  },
  props: {
    auditFinaceDetails: {}
  },
  watch: {
    auditFinaceDetails() {
      this.getDetails();
    }
  },
  mounted() {
    if (this.auditFinaceDetails != undefined) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.auditFinaceDetails;
      if (this.details.invoice_date != "") {
        this.invoice_date = this.details.invoice_date.substring(0, 10);
      }
      this.invoice_amount = Number(this.details.amount);
      //   console.log(this.details);
    },
    auditReject() {
      this.rejectIsShow = true;
    },
    verify() {
      let fls = true;
      // console.log(this.details.type);
      if (this.details.type == 1) {
        if (this.invoice_amount == null) {
          fls = false;
          this.$message.warning("请输入开票金额");
        }
      }
      if (this.is_ticket == "") {
        fls = false;
        this.$message.warning("请选择票据情况");
      }
      return fls;
    },
    auditPass() {
      let fls = this.verify();
      // console.log(fls);
      if (fls) {
        this.auditIsShow = false;
        this.auditPassHttp();
        this.changeTicket();
        // let _this = this;
        // this.$confirm({
        //   title: "提示",
        //   cancelText: "取消",
        //   okText: "确认",
        //   content: "该笔费用财务审核通过",
        //   onOk() {

        //   },
        //   onCancel() {
        //     _this.auditIsShow = true;
        //     _this.$emit("hideInDialogFinance", false);
        //   }
        // });
      }
    },
    changeTicket() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/updateIsTicket";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          id: this.details.id,
          is_ticket: this.is_ticket
        })
        .then(res => {
          if (res.data.code == 200) {
            // this.$message.success("修改成功！");
            // this.reload();
          }
        });
    },
    auditPassHttp() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/financeCheckPass";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        id: this.details.id,
        invoice_date: moment(this.invoice_date).format("YYYY-MM-DD"),
        invoice_amount: this.invoice_amount
      };
      if (this.details.type == 2) {
        delete params.invoice_date;
        delete params.invoice_amount;
      }
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.invoice_amount = null;
          this.$emit("hideInDialogFinance", true);
          this.$message.success("费用已审核通过");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    rejectCancel() {
      this.$emit("hideInDialogFinance", false);
    },
    rejectSure() {
      if (this.reason != "") {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.finance +
          "finance/financeCheckReject";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          reason: this.reason,
          id: this.details.id
        };
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("申请已驳回");
            this.reason = "";
            this.rejectIsShow = false;
            this.$emit("hideInDialogFinance", true);
          } else {
            this.rejectIsShow = false;
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.warning("请输入驳回原因！");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.dialogsBox > div > ul > .labelHeight {
  label {
    line-height: 32px;
  }
}
</style>
